'use client';

import { useEffect } from 'react';

import { ampli } from '@/ampli';
import type { ProductCategory } from '@/app/api/lib/products/product.types';
import { trackEvent } from '@/configurations/tracking/track';

/**
 * Émet `Product List Viewed` pour le couple DMC × catégorie affiché.
 *
 * Monté à l'intérieur de `DmcProductsPage` et indexé sur la catégorie ACTIVE,
 * pas sur le search param initial : le `CategorySwitcher` change de catégorie
 * via `history.replaceState`, sans navigation ni re-render RSC. Un tracking
 * posé au seul montage sous-compterait donc toutes les vues obtenues par
 * switch (cf. « When to trigger » du plan de tracking).
 */
export function ProductListViewTracker({
    dmcId,
    category,
}: {
    dmcId: string;
    category: ProductCategory | null;
}) {
    useEffect(() => {
        if (!dmcId || !category) return;

        trackEvent(() => ampli.productListViewed({ dmc_id: dmcId, product_category: category }));
    }, [dmcId, category]);

    return null;
}
